import { useCallback } from 'react';
import { useEvent } from 'react-use';
import { appRefreshAll } from 'data/app/actions';
import { useAppDispatch, useAppSelector } from 'app-components/hooks/redux';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

export const useAutoRefresh = () => {
  const dispatch = useAppDispatch();
  const autoRefresh = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'autoRefresh'));
  const onVisibilityChange = useCallback(() => {
    if (autoRefresh && document.visibilityState === 'visible') {
      dispatch(appRefreshAll(undefined, { context: 'visibilityChange' }));
    }
  }, [autoRefresh, dispatch]);
  useEvent('visibilitychange', onVisibilityChange);
};

export default useAutoRefresh;
